module.exports = __webpack_public_path__ + "img/main_logo.6630d352.png";